import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { Grid } from '@mui/material'

import { selectFunderProfileInfo } from 'store/selectors/profile'
import FunderProgramDescription from './components/FunderProgramDescription'
import FunderProgramInfo from './components/FunderProgramInfo'
import FunderPrograms from 'components/FunderPrograms'

const ProfilePrograms = ({ gotoTab, extra }) => {
  const { funderPrograms, isLoading } = useSelector(selectFunderProfileInfo)

  const [programIndex, setProgramIndex] = useState(0)

  const onProgramIndexChange = newIndex => {
    setProgramIndex(newIndex)
    gotoTab(ProfilePrograms, [funderPrograms[newIndex].id])
  }

  const programId = +extra

  useEffect(() => {
    if (isLoading) return
    const index = funderPrograms.findIndex(program => program.id === programId)
    if (index >= 0) {
      setProgramIndex(index)
    } else {
      gotoTab(ProfilePrograms)
    }
  }, [programId, funderPrograms])

  return (
    <Grid container columns={24}>
      <Grid size={{ xs: 24, sm: 24, md: 5 }}>
        <FunderPrograms
          funderPrograms={funderPrograms}
          programIndex={programIndex}
          setProgramIndex={onProgramIndexChange}
        />
      </Grid>
      <Grid size={{ xs: 24, sm: 24, md: 9 }}>
        <FunderProgramDescription funderProgram={funderPrograms[programIndex]} />
      </Grid>
      <Grid size={{ xs: 24, sm: 24, md: 10 }}>
        <FunderProgramInfo funderProgram={funderPrograms[programIndex]} />
      </Grid>
    </Grid>
  )
}

ProfilePrograms.isEnabled = ({ isFunderDissolved, showPrograms }) =>
  !isFunderDissolved && showPrograms
ProfilePrograms.tabPath = 'programs'
ProfilePrograms.getTabName = t => t.funder.programs

export default ProfilePrograms
